// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import QuestionTemplateModal from './QuestionTemplateModal';
import CustomQuestionModal from './CustomQuestionModal';
import CustomQuestionsTable from './CustomQuestionsTable';
import QuestionTemplatesTable from './QuestionTemplatesTable';
import SectionHeader from 'components/text/SectionHeader';

class QuestionTemplatesArea extends React.PureComponent {
  render() {
    return (
      <div>
        <div style={{ width: 550, maxWidth: '100%' }}>
          <div style={{ maxWidth: '100%' }}>
            <div style={{ position: 'relative' }}>
              <SectionHeader>QUESTIONNAIRES</SectionHeader>
              <QuestionTemplateModal {...this.props} />
              <QuestionTemplatesTable {...this.props} />
            </div>
            <div style={{ marginTop: 50 }}>
              <div style={{ position: 'relative' }}>
                <SectionHeader>CUSTOM QUESTIONS</SectionHeader>
                <CustomQuestionModal {...this.props} />
                <CustomQuestionsTable {...this.props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default QuestionTemplatesArea;



// WEBPACK FOOTER //
// ./src/routes/app-studio/QuestionTemplatesArea/index.js